module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', {
    staticClass: "toast-wrapper"
  }, [_c('div', {
    staticClass: "toast"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.msg && _vm.msg.length ? _vm.msg : '正在加载中...'))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1be92398!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast.vue
// module id = 407
// module chunks = 11 12 13 14 15 16 19